authAsAttributes